<template>
  <Dialog class="add-list-dialog" title="加入零件清单" :showFooter="false" @close="$emit('close')" ref="dialog">
    <div class="wrap" v-loading="loading">
      <table v-if="records.length" class="table table-hover font12">
        <thead>
          <tr>
            <th style="width:120px">名称</th>
            <th>描述</th>
            <th style="width:60px">商品数</th>
            <th style="width:1px"></th>
          </tr>
        </thead>
        <tbody>
          <tr @click="save(i)" v-for="i in records" :key="i.id" class="tb-tr">
            <td>{{i.name}}</td>
            <td>{{i.description}}</td>
            <td>{{i.total}}</td>
            <td class="text-center">
              <a class="btn btn-sm btn-icon btn-secondary" @click.stop="remove(i.id)">
                <i class="far fa-trash-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="default-list">
        <div class="tit">暂无清单！</div>
        <strong class="buttom" @click="save()">加入默认清单</strong>
      </div>
    </div>
  </Dialog>
</template>

<script >
import Dialog from "@/components/Dialog.vue";

export default {
  data() {
    return { records: [], loading: false };
  },
  props: ["commodity"],
  components: {
    Dialog
  },
  created() {
    this.getData();
  },
  methods: {
    save(it) {
      this.getList(it && it.id).then(res => {
        if (res.some(it => it.commodityId == this.commodity.sourceId)) return $msg.warning("商品已存在于该清单中！");
        let params = {
          commodityId: this.commodity.sourceId,
          number: this.commodity.number,
          productNumber: this.commodity.productNumber,
          name: this.commodity.name,
          genericCommodity: this.commodity.genCmdtyName,
          price: this.commodity.price,
          collectionId: it ? it.id : undefined,
          collectionName: it ? it.name : "默认清单"
        };
        this.$post("/bhome/favCmdties/save", params)
          .then(res => {
            this.getData();
            $msg.msg("加入成功！");
          })
          .catch(err => {});
      });
    },
    getList(id) {
      return new Promise((resolve, reject) => {
        if (id) {
          this.$post("/bhome/favCmdties/query/" + id)
            .then(res => resolve(res))
            .catch(err => {});
        } else {
          resolve([]);
        }
      });
    },
    getData() {
      this.loading = true;
      this.$post("/bhome/favCols/query")
        .then(res => {
          this.records = res;
          this.loading = false;
        })
        .catch(err => {});
    },
    remove(id) {
      $alert({
        type: "remove",
        title: "确定删除吗？",
        text: "一旦删除将无法恢复，请确定是否继续。",
        ok: () => {
          this.$list("/bhome/favCols/destroy/" + id, {})
            .then(res => this.getData())
            .catch(err => {});
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  height: 320px;
  overflow: auto;
  .table {
    .tb-tr {
      cursor: pointer;
      td {
        vertical-align: middle;
      }
    }
  }
  .default-list {
    text-align: center;
    .tit {
      margin: 20px 0 50px;
    }
    .buttom {
      width: 200px;
      border-radius: 22px;
      display: inline-block;
      border: 1px solid rgb(204, 204, 204);
      line-height: 44px;
      cursor: pointer;
      &:hover {
        background: #f2f2f2;
        border: 1px solid #f2f2f2;
      }
    }
  }
}
</style>